import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-209f1b9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Contact me ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://artiomsklyarov.t.me",
  target: "_blank",
  class: "contact main-contact"
}, [
  /*#__PURE__*/_createTextVNode(" @ArtiomSklyarov "),
  /*#__PURE__*/_createElementVNode("span", { class: "sub" }, "Telegram")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:hi@artyom.io?subject=a%20humble%20request",
  target: "_blank",
  class: "contact letter"
}, [
  /*#__PURE__*/_createTextVNode(" hi@artyom.io "),
  /*#__PURE__*/_createElementVNode("span", { class: "sub" }, "email")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "work" }, [
  /*#__PURE__*/_createElementVNode("a", null, "← Go back")
], -1))

import ViewContainer from '../components/ViewContainer.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(ViewContainer, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("h1", null, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})